export interface IApiKey {
    active: boolean;
    api_key: string;
    deleted_at?: string;
    expire_at: string;
    id?: string;
    ip: string;
    name: string;
}
